import { createAction } from "@reduxjs/toolkit";
export const RegisterAction = createAction("REGISTER");
export const EditBasicInfoAction = createAction("EDIT_BASIC_INFO");
export const ChangePasswordAction = createAction("CHANGE_PASSWORD_ACTION");
export const LoginAction = createAction("LOGIN");
export const AdminLoginAction = createAction("Admin_LOGIN");
export const LogoutAction = createAction("LOGOUT");
export const OTPAction = createAction("OTP");
export const SendOtpAction = createAction("SEND_OTP");
export const VerifyOtpAction = createAction("VERIFY_OTP");
export const ResendPasswordAction = createAction("ResendPassword");
export const resetPasswordRequestAction = createAction(
  "RESET_PASSWORD_REQUEST_ACTION"
);
export const resetPasswordAction = createAction("RESET_PASSWORD_ACTION");
export const ToggleWishlistItemAction = createAction("TOGGLE_WISHLIST_ITEM");
export const GetUserDetail = createAction("GET_USER_DETAIL");
export const GetMySubscription = createAction("GET_MY_SUBSCRIPTION");
export const GetWishlistItemsAction = createAction("GET_WISHLIST_ITEMS");
export const GetAllPaymentMethods = createAction("GET_ALL_PAYMENT_METHODS");
export const GetSubscriptionList = createAction("GET_SUBSCRIPTION_LIST");
export const UpdateSubscription = createAction("UPDATE_SUBSCRIPTION");
export const CancelSubscription = createAction("CANCEL_SUBSCRIPTION");
export const RenewSubscription = createAction("RENEW_SUBSCRIPTION");
// home actions---------------------
export const GetBanners = createAction("GET_BANNERS");
export const GetHomeData = createAction("GET_HOME_DATA");
export const GetDashBoardData = createAction("GET_DASHBOARD_DATA");
export const GetItemsByCategory = createAction("GET_ITEMS_CATEGORY");

// key  action----------------------
export const GetItemDetail = createAction("GET_ITEM_DETAIL");
export const GetSimilarItems = createAction("GET_SIMILAR_ITEMS");
export const ViewItemAction = createAction("VIEW_ITEM");
export const GetBuyItemsAction = createAction("GET_Buy_ITEMS");
export const GetKeysAction = createAction("GET_KEYS");
export const GenerateKeyAction = createAction("GENERATE_KEY");

// alerts action----------------------
export const GetAlertsAction = createAction("GET_ALERTS");
export const CreateAlertAction = createAction("CREATE_ALERT");
export const UpdateAlertAction = createAction("UPDATE_ALERT");
export const DeleteAlertAction = createAction("DELETE_ALERT");
export const ToggleAlertAction = createAction("TOGGLE_ALERT");
